import { uniqueId } from 'lodash';
import { unreachable } from '../../../../ts-utils';
const LOCAL_REVISION_ID_PREFIX = 'local-';
export const createLocalHistoryRevision = (comment, currentOwner) => {
    const author = (() => {
        switch (currentOwner.type) {
            case 'MEMBER':
                return { type: 'MEMBER', member: currentOwner.member };
            case 'ANONYMOUS':
                return { type: 'VISITOR', id: currentOwner.identityId };
            case 'UNKNOWN':
                return { type: 'UNKNOWN' };
            default:
                throw unreachable(currentOwner);
        }
    })();
    return {
        revisionId: createLocalRevisionId(),
        content: comment.content?.richContent,
        createdAt: comment.createdAt,
        author,
    };
};
const createLocalRevisionId = () => uniqueId(LOCAL_REVISION_ID_PREFIX);
export const checkIfRevisionIsLocal = (revisionId) => {
    return revisionId.startsWith(LOCAL_REVISION_ID_PREFIX);
};
//# sourceMappingURL=history-utils.js.map